import { Future } from '@/components/future';

export default function FuturePage() {
  return <Future />;
}
